import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  fr: { translation: fr },
  de: { translation: de },
  es: { translation: es }
};

// Supported language codes for validation
const SUPPORTED_LANGS = ['en', 'ar', 'fr', 'de', 'es'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      // Order: Check localStorage first (user preference), then browser language
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      // Map common language codes to our supported languages
      lookupLocalStorage: 'i18nextLng',
      // Only check first part of language code (e.g., 'en-US' -> 'en')
      convertDetectedLanguage: (lng) => {
        if (!lng) return 'en';
        const baseLang = lng.split('-')[0].toLowerCase();
        return SUPPORTED_LANGS.includes(baseLang) ? baseLang : 'en';
      }
    }
  });

export default i18n;
